import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "file-manager-wrapper" }
const _hoisted_2 = { class: "project-documents-section" }
const _hoisted_3 = { class: "upload-btn-wrapper" }
const _hoisted_4 = {
  key: 1,
  class: "embedded-header"
}
const _hoisted_5 = { class: "upload-btn-wrapper" }
const _hoisted_6 = {
  key: 2,
  class: "project-context"
}
const _hoisted_7 = { class: "project-context-content" }
const _hoisted_8 = { class: "project-info" }
const _hoisted_9 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_10 = { class: "loading-content" }
const _hoisted_11 = {
  key: 1,
  class: "error-message"
}
const _hoisted_12 = { class: "error-content" }
const _hoisted_13 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_14 = { class: "empty-content" }
const _hoisted_15 = {
  key: 3,
  class: "files-container"
}
const _hoisted_16 = { class: "stats-section" }
const _hoisted_17 = { class: "stat-card" }
const _hoisted_18 = { class: "stat-number" }
const _hoisted_19 = { class: "stat-label" }
const _hoisted_20 = { class: "stat-card" }
const _hoisted_21 = { class: "stat-number" }
const _hoisted_22 = { class: "stat-label" }
const _hoisted_23 = { class: "stat-card" }
const _hoisted_24 = { class: "stat-number" }
const _hoisted_25 = { class: "stat-label" }
const _hoisted_26 = { class: "controls-section" }
const _hoisted_27 = { class: "controls-header" }
const _hoisted_28 = { class: "controls-title" }
const _hoisted_29 = { class: "filter-section" }
const _hoisted_30 = { class: "filter-left" }
const _hoisted_31 = { class: "filter-label" }
const _hoisted_32 = { class: "filter-chips" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "chip-count" }
const _hoisted_35 = { class: "filter-right" }
const _hoisted_36 = { class: "filter-label" }
const _hoisted_37 = { class: "page-size-selector" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "documents-section" }
const _hoisted_40 = { class: "documents-grid" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "document-header" }
const _hoisted_43 = { class: "document-info" }
const _hoisted_44 = { class: "document-name" }
const _hoisted_45 = { class: "document-type-badge" }
const _hoisted_46 = { class: "document-meta" }
const _hoisted_47 = { class: "meta-row" }
const _hoisted_48 = { class: "file-size" }
const _hoisted_49 = { class: "meta-row" }
const _hoisted_50 = { class: "file-date" }
const _hoisted_51 = {
  key: 0,
  class: "meta-row"
}
const _hoisted_52 = { class: "document-actions" }
const _hoisted_53 = ["title", "onClick"]
const _hoisted_54 = ["title", "onClick"]
const _hoisted_55 = ["title", "onClick"]
const _hoisted_56 = ["title", "onClick"]
const _hoisted_57 = {
  key: 0,
  class: "pagination-section"
}
const _hoisted_58 = { class: "pagination-controls" }
const _hoisted_59 = ["disabled", "title"]
const _hoisted_60 = ["disabled", "title"]
const _hoisted_61 = { class: "pagination-info" }
const _hoisted_62 = { class: "page-numbers" }
const _hoisted_63 = { class: "items-info" }
const _hoisted_64 = ["disabled", "title"]
const _hoisted_65 = ["disabled", "title"]

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from '@/composables/useStore';
import { useProjectStore, useAuthStore } from '@/stores';
import { useNotifications } from '@/composables/useNotifications';
import { usePermissions } from '@/composables/usePermissions';
import DocumentService from '@/services/documents.service';
import type { UploadedFile } from '@/types';

import AppCard from '../../base/AppCard.vue';
import AppButton from '../../base/AppButton.vue';
import AppPageHeader from '../../base/AppPageHeader.vue';
import AppDataGrid from '../../base/AppDataGrid.vue';
import FileUploadModal from './FileUploadModal.vue';
import DocumentUploadModal from './DocumentUploadModal.vue';
import DeleteConfirmationModal from './DeleteConfirmationModal.vue';
import DocumentAnnotator from './DocumentAnnotator.vue';

// Props
import DocumentViewerModal from './DocumentViewerModal.vue';
import PermissionGuard from '../../common/PermissionGuard.vue';
import { PermissionType } from '@/services/permission.service';

// Detect FULL_MANAGEMENT from the current project in the store
interface Props {
  projectId?: string | number | null;
}

interface Emits {
  (e: 'document-selected', document: UploadedFile): void;
  (e: 'return-to-project'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDocuments',
  props: {
    projectId: { default: null }
  },
  emits: ["document-selected", "return-to-project"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

// Emits
const emit = __emit;

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const { notifySuccess, notifyError } = useNotifications();
const { hasPermissionForProject } = usePermissions();
const projectStore = useProjectStore();
const authStore = useAuthStore();

const isFullManagement = computed(() =>
  projectStore.currentProject?.managementType === 'FULL_MANAGEMENT'
)

const isClientUser = computed(() => authStore.user?.type === 'CLIENT')

// Data
const files = ref<any[]>([]);
const showDeleteConfirmation = ref(false);
const fileToDelete = ref<any>(null);
const sourceProject = ref<any>(null);
const gridApi = ref<any>(null);
const gridColumnApi = ref<any>(null);
const error = ref<string | null>(null);
const loading = ref(false);
const uploading = ref(false);
const showDocumentViewer = ref(false);
const selectedDocument = ref<any>(null);
const uploadProgress = ref(0);
const showUploadModal = ref(false);
const isInitialLoad = ref(true);
const selectedDocType = ref('all');
const showDocumentAnnotator = ref(false);
const selectedDocumentForAnnotation = ref<any>(null);
const documentAnnotatorUrl = ref<string | null>(null);

// Pagination state
const currentPage = ref(1);
const pageSize = ref(12); // Number of documents per page for grid layout
const pageSizeOptions = [6, 12, 24, 48]; // Available page size options

// Watch for projectId changes
watch(() => props.projectId, () => {
  // Handle projectId changes
}, { immediate: true });

const uniqueDocTypes = computed(() => {
  const types = new Map();
  types.set('all', files.value.length);
  
  files.value.forEach((file: any) => {
    const count = types.get(file.docType) || 0;
    types.set(file.docType, count + 1);
  });
  
  return Array.from(types.entries()).map(([type, count]) => ({
    type,
    count
  }));
});

const filteredFiles = computed(() => {
  let result = files.value;
  
  // Filter by document type
  if (selectedDocType.value !== 'all') {
    result = result.filter((file: any) => file.docType === selectedDocType.value);
  }
  
  return result;
});

// Paginated files for display
const paginatedFiles = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return filteredFiles.value.slice(start, end);
});

// Pagination computed properties
const totalPages = computed(() => {
  return Math.ceil(filteredFiles.value.length / pageSize.value);
});

const shouldShowPagination = computed(() => {
  return filteredFiles.value.length > pageSize.value;
});

const getFileIcon = (filename: string) => {
  if (!filename) return '';

  const extension = filename.split('.').pop()?.toLowerCase();

  const iconMap: Record<string, string> = {
    'pdf': '<i class="fas fa-file-pdf" style="color: #e74c3c;"></i>',
    'doc': '<i class="fas fa-file-word" style="color: #2980b9;"></i>',
    'docx': '<i class="fas fa-file-word" style="color: #2980b9;"></i>',
    'xls': '<i class="fas fa-file-excel" style="color: #27ae60;"></i>',
    'xlsx': '<i class="fas fa-file-excel" style="color: #27ae60;"></i>',
    'ppt': '<i class="fas fa-file-powerpoint" style="color: #e67e22;"></i>',
    'pptx': '<i class="fas fa-file-powerpoint" style="color: #e67e22;"></i>',
    'jpg': '<i class="fas fa-file-image" style="color: #3498db;"></i>',
    'jpeg': '<i class="fas fa-file-image" style="color: #3498db;"></i>',
    'png': '<i class="fas fa-file-image" style="color: #3498db;"></i>',
    'gif': '<i class="fas fa-file-image" style="color: #3498db;"></i>',
    'zip': '<i class="fas fa-file-archive" style="color: #8e44ad;"></i>',
    'rar': '<i class="fas fa-file-archive" style="color: #8e44ad;"></i>',
    'txt': '<i class="fas fa-file-alt" style="color: #7f8c8d;"></i>',
    'mp3': '<i class="fas fa-file-audio" style="color: #f39c12;"></i>',
    'mp4': '<i class="fas fa-file-video" style="color: #d35400;"></i>',
  };

  return extension ? (iconMap[extension] || '<i class="fas fa-file" style="color: #95a5a6;"></i>') : '';
};

// Get file type for annotation
const getFileType = (file: any) => {
  const fileName = file?.fileName || file?.originalName || file?.name || '';
  return fileName.split('.').pop()?.toLowerCase() || '';
};

// Get file type category for styling
const getFileTypeCategory = (fileName: string): string => {
  const extension = fileName?.split('.').pop()?.toLowerCase() || '';
  
  if (extension === 'pdf') return 'pdf';
  if (['doc', 'docx'].includes(extension)) return 'word';
  if (['xls', 'xlsx'].includes(extension)) return 'excel';
  if (['ppt', 'pptx'].includes(extension)) return 'powerpoint';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(extension)) return 'image';
  if (['txt', 'csv', 'xml'].includes(extension)) return 'text';
  if (['zip', 'rar', '7z'].includes(extension)) return 'archive';
  
  return 'default';
};

// Get file icon class for Font Awesome
const getFileIconClass = (fileName: string): string => {
  const category = getFileTypeCategory(fileName);
  
  const iconMap: Record<string, string> = {
    pdf: 'fas fa-file-pdf',
    word: 'fas fa-file-word',
    excel: 'fas fa-file-excel',
    powerpoint: 'fas fa-file-powerpoint',
    image: 'fas fa-file-image',
    text: 'fas fa-file-alt',
    archive: 'fas fa-file-archive',
    default: 'fas fa-file'
  };
  
  return iconMap[category] || iconMap.default;
};

// Format total file size
const formatTotalSize = (): string => {
  const totalBytes = files.value.reduce((sum: number, file: any) => sum + (file.fileSize || 0), 0);
  return formatFileSize(totalBytes);
};

// Get count of recent files (uploaded in last 7 days)
const getRecentFilesCount = (): number => {
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
  
  return files.value.filter((file: any) => {
    const fileDate = new Date(file.lastModified || file.createdAt || 0);
    return fileDate > threeDaysAgo;
  }).length;
};

// Format file size helper
const formatFileSize = (bytes: number | undefined): string => {
  if (!bytes || bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(1));
  return `${size} ${sizes[i]}`;
};

// Format date helper
const formatDate = (dateString: string | Date | null | undefined): string => {
  if (!dateString) return t('documents.noDate');
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return t('documents.invalidDate');
    return date.toLocaleDateString();
  } catch (error) {
    return t('documents.invalidDate');
  }
};

// Get filter chip label helper
const getFilterChipLabel = (type: string): string => {
  if (type === 'all') return t('common.all');
  
  // Map file extensions to user-friendly labels
  const typeLabels: Record<string, string> = {
    'pdf': 'PDF',
    'doc': 'Word',
    'docx': 'Word',
    'xls': 'Excel',
    'xlsx': 'Excel',
    'ppt': 'PowerPoint',
    'pptx': 'PowerPoint',
    'txt': t('documents.types.text'),
    'jpg': t('documents.types.image'),
    'jpeg': t('documents.types.image'),
    'png': t('documents.types.image'),
    'gif': t('documents.types.image'),
    'zip': t('documents.types.archive'),
    'rar': t('documents.types.archive'),
    '7z': t('documents.types.archive')
  };
  
  return typeLabels[type.toLowerCase()] || type.toUpperCase();
};

// Handle upload button click
const handleUploadClick = () => {
  if (!props.projectId) {
    const errorMsg = t('notifications.selectFirmFirst');
    notifyError(errorMsg);
    error.value = errorMsg;
    return;
  }
    showUploadModal.value = true;
};

// Grid Configuration - make reactive to language changes
const columnDefs = computed(() => [
  {
    headerName: '#',
    field: 'rowNumber',
    valueGetter: (params: any) => params.node.rowIndex + 1,
    width: 70,
    pinned: 'left',
    suppressMenu: true,
    sortable: false,
    filter: false,
    resizable: false,
  },
  {
    field: 'fileType',
    headerName: '',
    width: 60,
    cellRenderer: (params: any) => {
      const span = document.createElement('span');
      span.innerHTML = getFileIcon(params.data.fileName);
      return span;
    },
    resizable: false,
    sortable: false,
    filter: false
  },
  {
    field: 'fileName',
    headerName: t('documents.filename'),
    type: 'text',
    sortable: true,
    resizable: true,
    flex: 1,
    minWidth: 150
  },
  {
    field: 'docType',
    headerName: t('documents.documentType'),
    type: 'text',
    sortable: true,
    resizable: true,
    minWidth: 100
  },
  {
    field: 'createdAt',
    headerName: t('documents.uploadDate'),
    type: 'date',
    sortable: true,
    resizable: true,
    minWidth: 180
  }
]);

// Actions configuration for AppDataGrid - make reactive to language changes
const actions = computed(() => {
  const baseActions = [
    {
      name: 'view',
      icon: 'fas fa-eye',
      label: t('documents.view'),
      tooltip: t('documents.view'),
      class: 'view-btn'
    },
    {
      name: 'download',
      icon: 'fas fa-download',
      label: t('documents.download'),
      tooltip: t('documents.download'),
      class: 'download-btn'
    }
  ];

  // Add annotate action if user has permission and document is annotatable
  if (hasPermissionForProject(PermissionType.UPLOAD_DOCUMENT, props.projectId).value) {
    baseActions.push({
      name: 'annotate',
      icon: 'fas fa-pencil-alt',
      label: t('annotation.annotate'),
      tooltip: t('annotation.annotate'),
      class: 'annotate-btn',
      // Show annotate only for supported file types
      condition: (data: any) => {
        const annotableTypes = ['jpg', 'jpeg', 'png', 'pdf', 'gif', 'webp', 'bmp'];
        const fileName = data?.fileName || data?.originalName || data?.name || '';
        const fileType = fileName.split('.').pop()?.toLowerCase() || '';
        return annotableTypes.includes(fileType);
      }
    } as any);
  }

  // Only add delete action if user has permission
  if (hasPermissionForProject(PermissionType.DELETE_DOCUMENT, props.projectId).value) {
    baseActions.push({
      name: 'delete',
      icon: 'fas fa-trash',
      label: t('documents.delete'),
      tooltip: t('documents.delete'),
      class: 'delete-btn',
      // Show delete only when current user is the creator (createdBy)
      condition: (data: any) => {
        try {
          const user = store.getters.getUser.value;
          if (!user) return false;
          const uid = String(user.id || '');
          return data?.createdBy && String(data.createdBy) === uid;
        } catch (e) {
          return false;
        }
      }
    } as any);
  }

  return baseActions;
});

const defaultColDef = {
  resizable: true,
  wrapText: false,
  autoHeight: false,
};

// Fetch files
const fetchFiles = async (force = false) => {
  if (!props.projectId) {
    const errorMsg = t('notifications.selectProjectFirst');
    notifyError(errorMsg);
    error.value = errorMsg;
    files.value = [];
    return;
  }

  // Prevent double loading unless forced
  if (loading.value || (!force && !isInitialLoad.value)) {
    return;
  }

  loading.value = true;
  error.value = null;
  try {
    const response = await DocumentService.getProjectDocuments(props.projectId);
    files.value = response || [];
    isInitialLoad.value = false;
  } catch (err: any) {
    console.error('Error fetching files:', err);
    
    let errorMessage = t('errors.loadingFilesError');
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    notifyError(errorMessage);
    error.value = errorMessage;
  } finally {
    loading.value = false;
  }
};

// Grid event handlers
const onGridReady = (params: any) => {
  gridApi.value = params.api;
  gridColumnApi.value = params.columnApi;

  // Auto-size all columns to fit the content
  if (gridApi.value) {
    setTimeout(() => {
      gridApi.value.sizeColumnsToFit();
    }, 100);
  }
};
// File upload handling
const handleFileSelected = async (formData: FormData) => {
  uploading.value = true;
  uploadProgress.value = 0;

  try {
    // Provide axios upload progress handler to update UI
    await DocumentService.uploadProjectDocuments(props.projectId, formData, (progressEvent: any) => {
      try {
        if (!progressEvent) return
        // AxiosProgressEvent may have 'loaded' and 'total'
        const loaded = (progressEvent.loaded as number) || 0
        const total = (progressEvent.total as number) || 0
        if (total > 0) {
          uploadProgress.value = Math.round((loaded / total) * 100)
        } else {
          // If total is not available, keep at 0 until completed
          uploadProgress.value = 0
        }
      } catch (e) {
        // ignore progress parsing errors
      }
    })
    showUploadModal.value = false;
    notifySuccess(t('documents.uploadSuccess'));
    // Ensure progress reflects completion
    uploadProgress.value = 100
    await fetchFiles(true);
  } catch (err: any) {
    console.error('Error uploading file:', err);
    
    // Extract meaningful error message
    let errorMessage = t('errors.uploadingFileError');
    
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    notifyError(errorMessage);
    
    // Keep the local error for any UI that might need it
    error.value = errorMessage;
  } finally {
    uploading.value = false;
  }
};

// File deletion handling
const downloadFile = async (file: any) => {
  if (!props.projectId || !file?.id) {
    const errorMsg = t('errors.invalidFileDownload');
    notifyError(errorMsg);
    error.value = errorMsg;
    return;
  }

  try {
    loading.value = true;
    await DocumentService.downloadDocument(props.projectId, file.id, file.fileName);
  } catch (err: any) {
    console.error('Error downloading file:', err);
    
    let errorMessage = t('errors.downloadingFileError');
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    notifyError(errorMessage);
    error.value = errorMessage;
  } finally {
    loading.value = false;
  }
};

const promptDeleteFile = (file: any) => {
  if (loading.value) return; // Prevent opening delete modal while loading
  fileToDelete.value = file;
  showDeleteConfirmation.value = true;
};

// View document
const viewDocument = (file: any) => {
  if (loading.value) return; // Prevent opening viewer while loading
  selectedDocument.value = file;
  showDocumentViewer.value = true;
};

// Annotate document
const annotateDocument = async (file: any) => {
  if (loading.value || !props.projectId || !file?.id) return;

  try {
    loading.value = true;
    
    // Get document data for annotation
    const result = await DocumentService.getDocumentForView(props.projectId, file.id);
    
    if (result && result.data instanceof Blob) {
      // Clean up previous URL if exists
      if (documentAnnotatorUrl.value) {
        URL.revokeObjectURL(documentAnnotatorUrl.value);
      }
      
      // Create new object URL for the document
      documentAnnotatorUrl.value = URL.createObjectURL(result.data);
      selectedDocumentForAnnotation.value = file;
      showDocumentAnnotator.value = true;
    } else {
      console.error('Invalid response format - expected a Blob object');
      notifyError(t('errors.invalidResponseFormat'));
    }
  } catch (err: any) {
    console.error('Error loading document for annotation:', err);
    let errorMessage = t('errors.loadingDocumentError');
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.message) {
      errorMessage = err.message;
    }
    notifyError(errorMessage);
  } finally {
    loading.value = false;
  }
};

// Close document viewer
const closeDocumentViewer = () => {
  showDocumentViewer.value = false;
  selectedDocument.value = null;
};

// Close document annotator
const closeDocumentAnnotator = () => {
  showDocumentAnnotator.value = false;
  selectedDocumentForAnnotation.value = null;
  
  // Clean up the object URL
  if (documentAnnotatorUrl.value) {
    URL.revokeObjectURL(documentAnnotatorUrl.value);
    documentAnnotatorUrl.value = null;
  }
};

// Handle annotation saved
const handleAnnotationSaved = () => {
  notifySuccess(t('annotation.savedSuccessfully'));
  closeDocumentAnnotator();
};

// Pagination methods
const goToFirstPage = () => {
  currentPage.value = 1;
};

const goToPreviousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const goToNextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const goToLastPage = () => {
  currentPage.value = totalPages.value;
};

// Reset to first page when filters or page size changes
watch([selectedDocType, pageSize], () => {
  currentPage.value = 1;
});

const isDeleting = ref(false);

const confirmDelete = async () => {
  if (!fileToDelete.value || !props.projectId || isDeleting.value) return;

  try {
    isDeleting.value = true;
    loading.value = true;
    await DocumentService.deleteProjectDocument(props.projectId, fileToDelete.value.id);
    showDeleteConfirmation.value = false;
    
    // Show success notification
    notifySuccess(t('notifications.fileDeleteSuccess'));
    
    // Clear deleted file reference
    fileToDelete.value = null;
    // Refresh file list after deletion
    await fetchFiles(true);
  } catch (err: any) {
    console.error('Error deleting file:', err);
    
    let errorMessage = t('errors.deletingFileError');
    if (err.response?.data?.message) {
      errorMessage = err.response.data.message;
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    notifyError(errorMessage);
    error.value = errorMessage;
  } finally {
    loading.value = false;
    isDeleting.value = false;
  }
};

// Cancel delete handler
const cancelDelete = () => {
  showDeleteConfirmation.value = false;
  fileToDelete.value = null;
};

// Handle action clicks from AppDataGrid
const handleAction = (action: any, data: any) => {
  if (action.name === 'view') {
    viewDocument(data);
  } else if (action.name === 'download') {
    downloadFile(data);
  } else if (action.name === 'annotate') {
    annotateDocument(data);
  } else if (action.name === 'delete') {
    promptDeleteFile(data);
  }
};

// Window resize handler
const onWindowResize = () => {
  if (gridApi.value) {
    setTimeout(() => {
      gridApi.value.sizeColumnsToFit();
    }, 100);
  }
};

// Define emits for parent components to listen to
// const emit = defineEmits(['return-to-project']); // Removed duplicate - now defined above

// Return to the project details page
const returnToProject = () => {
  // If this component is used inside a project details page, emit an event to parent
  // that will be handled by the ProjectDetails.vue's returnToProject method
  if (props.projectId) {
    emit('return-to-project');
    return;
  }

  // Otherwise navigate back to project (if coming from route)
  if (sourceProject.value && sourceProject.value.id) {
    router.push({
      path: '/project/' + sourceProject.value.id
    });
  } else {
    // Fallback to projects listing if something went wrong
    router.push('/projects');
  }
};

// Component lifecycle hooks
onMounted(async () => {
  // Load files when component mounts
  if (props.projectId) {
    await fetchFiles();
  } else {
    const errorMsg = t('notifications.selectFirmFirst');
    notifyError(errorMsg);
    error.value = errorMsg;
  }

  // Add resize event listener for the grid
  window.addEventListener('resize', onWindowResize);
});

onUnmounted(() => {
  // Remove resize event listener when component is unmounted
  window.removeEventListener('resize', onWindowResize);
  
  // Clean up annotator URL if it exists
  if (documentAnnotatorUrl.value) {
    URL.revokeObjectURL(documentAnnotatorUrl.value);
  }
});

// Watch for projectId changes
watch(() => props.projectId, async (newId: string | number | null) => {
  if (newId) {
    isInitialLoad.value = true;
    await fetchFiles();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!props.projectId)
        ? (_openBlock(), _createBlock(AppPageHeader, {
            key: 0,
            title: _ctx.$t('documents.title'),
            subtitle: _ctx.$t('documents.subtitle')
          }, {
            actions: _withCtx(() => [
              _createVNode(PermissionGuard, { permission: 'UPLOAD_DOCUMENT' }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_3, [
                    _createVNode(AppButton, {
                      variant: "primary",
                      size: "medium",
                      class: "upload-file-btn",
                      onClick: handleUploadClick,
                      disabled: uploading.value
                    }, {
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "btn-icon" }, "+", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('documents.uploadFile')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "subtitle"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "component-title" }, null, -1)),
            _createVNode(PermissionGuard, { permission: 'UPLOAD_DOCUMENT' }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: handleUploadClick
                  }, _toDisplayString(_ctx.$t('documents.uploadFile')), 1)
                ])
              ]),
              _: 1
            })
          ])),
      (sourceProject.value && !props.projectId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('documents.projectFiles', { projectName: sourceProject.value.name })), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('documents.projectFilesDescription')), 1)
              ]),
              _createVNode(AppButton, {
                variant: "outline",
                size: "small",
                onClick: returnToProject,
                class: "return-to-project-btn"
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "btn-icon" }, [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      width: "16",
                      height: "16"
                    }, [
                      _createElementVNode("path", {
                        fill: "currentColor",
                        d: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
                      })
                    ])
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('documents.returnToProject')), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(AppCard, { class: "mt-lg" }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "spinner" }, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('documents.loading')), 1)
                ])
              ]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-triangle error-icon" }, null, -1)),
                    _createElementVNode("p", null, _toDisplayString(error.value), 1),
                    _createElementVNode("button", {
                      class: "btn btn-outline",
                      onClick: fetchFiles
                    }, _toDisplayString(_ctx.$t('common.retry')), 1)
                  ])
                ]))
              : (files.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "empty-icon" }, [
                        _createElementVNode("i", { class: "fas fa-folder-open" })
                      ], -1)),
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('documents.noFiles.title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('documents.noFiles.description')), 1),
                      _createVNode(PermissionGuard, { permission: 'UPLOAD_DOCUMENT' }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: handleUploadClick
                          }, [
                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-plus" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('documents.uploadFirstFile')), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("section", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-header" }, [
                          _createElementVNode("div", { class: "stat-icon files" }, [
                            _createElementVNode("i", { class: "fas fa-file" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(files.value.length), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('documents.stats.totalFiles', { count: files.value.length })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-header" }, [
                          _createElementVNode("div", { class: "stat-icon storage" }, [
                            _createElementVNode("i", { class: "fas fa-database" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(formatTotalSize()), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('documents.stats.storageUsed')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-header" }, [
                          _createElementVNode("div", { class: "stat-icon recent" }, [
                            _createElementVNode("i", { class: "fas fa-clock" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(getRecentFilesCount()), 1),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('documents.stats.recentFiles', { count: getRecentFilesCount() })), 1)
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("h2", _hoisted_28, [
                          _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-filter" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('documents.filterByType')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('documents.documentType')) + ":", 1),
                          _createElementVNode("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueDocTypes.value, (docType) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: docType.type,
                                class: _normalizeClass(["filter-chip", { active: selectedDocType.value === docType.type }]),
                                onClick: ($event: any) => (selectedDocType.value = docType.type)
                              }, [
                                _createElementVNode("span", null, _toDisplayString(getFilterChipLabel(docType.type)), 1),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(docType.count), 1)
                              ], 10, _hoisted_33))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('common.pagination.itemsPerPage')) + ":", 1),
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageSize).value = $event)),
                              class: "page-size-dropdown"
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (size) => {
                                return _createElementVNode("option", {
                                  key: size,
                                  value: size
                                }, _toDisplayString(size), 9, _hoisted_38)
                              }), 64))
                            ], 512), [
                              [_vModelSelect, pageSize.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedFiles.value, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: file.id,
                            class: "document-card",
                            style: _normalizeStyle({ 'animation-delay': `${(index % 6) * 0.1 + 0.1}s` }),
                            tabindex: "0",
                            onClick: ($event: any) => (viewDocument(file))
                          }, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["document-icon", getFileTypeCategory(file.fileName)])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(getFileIconClass(file.fileName))
                                }, null, 2)
                              ], 2),
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("h3", _hoisted_44, _toDisplayString(file.fileName), 1),
                                _createElementVNode("span", _hoisted_45, _toDisplayString(file.docType || 'document'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-weight meta-icon" }, null, -1)),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(formatFileSize(file.fileSize)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-calendar meta-icon" }, null, -1)),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(formatDate(file.lastModified || file.createdAt || file.uploadDate)), 1)
                              ]),
                              (file.uploadedBy || file.createdBy)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-user meta-icon" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('documents.uploadedBy', { user: file.uploadedBy || file.createdBy || 'Admin' })), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("button", {
                                class: "action-button",
                                title: _ctx.$t('documents.actions.view'),
                                onClick: _withModifiers(($event: any) => (viewDocument(file)), ["stop"])
                              }, [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "fas fa-eye" }, null, -1)
                              ]))], 8, _hoisted_53),
                              (_unref(hasPermissionForProject)(_unref(PermissionType).UPLOAD_DOCUMENT, _ctx.projectId).value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "action-button annotate",
                                    title: _ctx.$t('documents.actions.annotate'),
                                    onClick: _withModifiers(($event: any) => (annotateDocument(file)), ["stop"])
                                  }, [...(_cache[17] || (_cache[17] = [
                                    _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
                                  ]))], 8, _hoisted_54))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "action-button",
                                title: _ctx.$t('documents.actions.download'),
                                onClick: _withModifiers(($event: any) => (downloadFile(file)), ["stop"])
                              }, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "fas fa-download" }, null, -1)
                              ]))], 8, _hoisted_55),
                              (_unref(hasPermissionForProject)(_unref(PermissionType).DELETE_DOCUMENT, _ctx.projectId).value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "action-button delete",
                                    title: _ctx.$t('documents.actions.delete'),
                                    onClick: _withModifiers(($event: any) => (promptDeleteFile(file)), ["stop"])
                                  }, [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                  ]))], 8, _hoisted_56))
                                : _createCommentVNode("", true)
                            ])
                          ], 12, _hoisted_41))
                        }), 128))
                      ]),
                      (shouldShowPagination.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["pagination-btn", { disabled: currentPage.value === 1 }]),
                                disabled: currentPage.value === 1,
                                onClick: goToFirstPage,
                                title: _ctx.$t('common.pagination.first')
                              }, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("i", { class: "fas fa-angle-double-left" }, null, -1)
                              ]))], 10, _hoisted_59),
                              _createElementVNode("button", {
                                class: _normalizeClass(["pagination-btn", { disabled: currentPage.value === 1 }]),
                                disabled: currentPage.value === 1,
                                onClick: goToPreviousPage,
                                title: _ctx.$t('common.pagination.previous')
                              }, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
                              ]))], 10, _hoisted_60),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('common.pagination.page')) + " " + _toDisplayString(currentPage.value) + " " + _toDisplayString(_ctx.$t('common.pagination.of')) + " " + _toDisplayString(totalPages.value), 1),
                                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('common.pagination.showing')) + " " + _toDisplayString((currentPage.value - 1) * pageSize.value + 1) + "-" + _toDisplayString(Math.min(currentPage.value * pageSize.value, filteredFiles.value.length)) + " " + _toDisplayString(_ctx.$t('common.pagination.of')) + " " + _toDisplayString(filteredFiles.value.length), 1)
                              ]),
                              _createElementVNode("button", {
                                class: _normalizeClass(["pagination-btn", { disabled: currentPage.value === totalPages.value }]),
                                disabled: currentPage.value === totalPages.value,
                                onClick: goToNextPage,
                                title: _ctx.$t('common.pagination.next')
                              }, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
                              ]))], 10, _hoisted_64),
                              _createElementVNode("button", {
                                class: _normalizeClass(["pagination-btn", { disabled: currentPage.value === totalPages.value }]),
                                disabled: currentPage.value === totalPages.value,
                                onClick: goToLastPage,
                                title: _ctx.$t('common.pagination.last')
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "fas fa-angle-double-right" }, null, -1)
                              ]))], 10, _hoisted_65)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
        ]),
        _: 1
      }),
      _createVNode(DocumentUploadModal, {
        show: showUploadModal.value,
        "project-id": _ctx.projectId,
        uploading: uploading.value,
        "show-client-visibility-toggle": isFullManagement.value && !isClientUser.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showUploadModal.value = false)),
        onUpload: handleFileSelected
      }, null, 8, ["show", "project-id", "uploading", "show-client-visibility-toggle"]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (uploading.value)
            ? (_openBlock(), _createBlock(FileUploadModal, {
                key: 0,
                progress: uploadProgress.value
              }, null, 8, ["progress"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (showDeleteConfirmation.value)
            ? (_openBlock(), _createBlock(DeleteConfirmationModal, {
                key: 0,
                filename: fileToDelete.value?.fileName || '',
                "doc-type": fileToDelete.value?.docType || '',
                description: fileToDelete.value?.description || '',
                loading: loading.value,
                onConfirm: confirmDelete,
                onCancel: cancelDelete
              }, null, 8, ["filename", "doc-type", "description", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (showDocumentViewer.value && selectedDocument.value)
            ? (_openBlock(), _createBlock(DocumentViewerModal, {
                key: 0,
                projectId: props.projectId,
                document: selectedDocument.value,
                onClose: closeDocumentViewer
              }, null, 8, ["projectId", "document"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showDocumentAnnotator.value && selectedDocumentForAnnotation.value && documentAnnotatorUrl.value)
          ? (_openBlock(), _createBlock(DocumentAnnotator, {
              key: 0,
              projectId: Number(props.projectId),
              documentId: Number(selectedDocumentForAnnotation.value.id),
              documentUrl: documentAnnotatorUrl.value,
              fileName: selectedDocumentForAnnotation.value.fileName || selectedDocumentForAnnotation.value.originalName || selectedDocumentForAnnotation.value.name,
              fileType: getFileType(selectedDocumentForAnnotation.value),
              onClose: closeDocumentAnnotator,
              onSaved: handleAnnotationSaved
            }, null, 8, ["projectId", "documentId", "documentUrl", "fileName", "fileType"]))
          : _createCommentVNode("", true)
      ]))
    ])
  ]))
}
}

})